import { fluid } from './fluid';

export default fluid;
